// extracted by mini-css-extract-plugin
export default {"pageWrap":"Sd-z","fullWidth":"Td-z","heading":"Ud-z","fullBleed":"Vd-z","hidden":"Wd-z"};